// Packages
import React from "react"
import PropTypes from "prop-types"

// Components
import MetalSwatch from "components/Stacker/components/MetalSwatch/MetalSwatch"

// Styles
import "./MetalSwatches.scss"

function MetalSwatches(props) {
  const {
    baseProductCode,

    entryNumber,
    isEditCart,
    isLink,
    isStackedProduct,
    productMetalVariants,
    productName,
    refinerId = null,
    // selectedSize,
    showTooltip = true,
  } = props

  return (
    <div className="MetalSwatches">
      <ul className="MetalSwatchList d-flex align-items-center">
        {productMetalVariants.map((metalVariant, index) => (
          <MetalSwatch
            baseCode={baseProductCode}
            entryNumber={entryNumber}
            isEditCart={isEditCart}
            isLink={isLink}
            isSelected={metalVariant.selected}
            isStackedProduct={isStackedProduct}
            key={`${baseProductCode}-${metalVariant.code}-${index}`}
            metalImage={metalVariant.metalImage}
            metalVariantCode={metalVariant.productCode}
            metalVariantName={metalVariant.name}
            productCode={metalVariant.productCode}
            productName={productName}
            refinerId={refinerId}
            showTooltip={showTooltip}
            url={metalVariant.url}
          />
        ))}
      </ul>
    </div>
  )
}

MetalSwatches.propTypes = {
  baseProductCode: PropTypes.string.isRequired,
  baseStore: PropTypes.string,
  entryNumber: PropTypes.string,
  isEditCart: PropTypes.bool,
  isLink: PropTypes.bool,
  isStackedProduct: PropTypes.bool,
  productMetalVariants: PropTypes.array,
  productName: PropTypes.string,
  refinerId: PropTypes.string,
  // selectedSize: PropTypes.object,
  shouldUpdateDataLayer: PropTypes.bool,
  shouldUpdateQuickViewLayer: PropTypes.bool,
  showTooltip: PropTypes.bool,
}

export default MetalSwatches
